<template>
  <div class="home-page">
    <!-- 骨架屏：首页主要内容占位 -->
    <transition name="skeleton-fade">
      <div v-if="showSkeleton" class="home-skeleton">
        <div class="skeleton-wrap">
          <div class="skeleton-header"></div>
          <div class="skeleton-banner"></div>
          <div class="skeleton-headlines">
            <div class="skeleton-headline-title"></div>
            <div class="skeleton-headline-list">
              <div v-for="i in 4" :key="i" class="skeleton-headline-item"></div>
            </div>
          </div>
          <div class="skeleton-carousel">
            <div class="skeleton-carousel-main"></div>
            <div class="skeleton-carousel-side">
              <div class="skeleton-side-top"></div>
              <div class="skeleton-side-btm"></div>
            </div>
          </div>
          <div class="skeleton-market"></div>
          <div class="skeleton-tags"></div>
          <div v-for="i in 4" :key="'sec-' + i" class="skeleton-section">
            <div class="skeleton-sec-title"></div>
            <div class="skeleton-sec-body">
              <div class="skeleton-sec-left"></div>
              <div class="skeleton-sec-right"></div>
            </div>
          </div>
          <div class="skeleton-ads-row">
            <div v-for="i in 3" :key="'ad-' + i" class="skeleton-ad-item"></div>
          </div>
          <div class="skeleton-video">
            <div class="skeleton-video-top"></div>
            <div class="skeleton-video-bottom"></div>
          </div>
          <div class="skeleton-partners"></div>
          <div class="skeleton-project"></div>
          <div class="skeleton-footer"></div>
        </div>
      </div>
    </transition>

    <PageHeader />
    <HomeBanner v-show="false" />
    <HomeBanner ref="fixedBanner" fixed :show="showFixedBanner" />
    <HomeHeadlines />
    <HomeCarousel />
    <HomeMarket :category-map="categoryMap" />
    <HomeTags ref="homeTags" />
    <HomeSection title="资讯 · 快消 · 农业" :category-id-list="[2, 3, 4]" :category-map="categoryMap" positionKey="index_category_1" listPosition="left" />
    <HomeAds positionKey="index_v_top" type="single" />
    <HomeVideo :category-map="categoryMap" />
    <HomeSection title="观察 · 科技 · 汽车" :category-id-list="[8, 10, 11]" :category-map="categoryMap" positionKey="index_category_2" listPosition="left" />
    <HomeAds positionKey="index_food_top" type="triple" />
    <HomeSection title="食品 · 文产 · 话题" :category-id-list="[5, 34, 6]" :category-map="categoryMap" positionKey="index_category_3" listPosition="right" reverse />
    <HomeSection title="品鉴 · 原创" :category-id-list="[7, 12]" :category-map="categoryMap" positionKey="index_category_4" listPosition="left" />
    <HomeAds positionKey="index_case_btm_banner" type="single" />
    <HomePartners />
    <HomeProject />
    <PageFooter />
  </div>
</template>

<script>
import PageHeader from '../detail/components/PageHeader.vue'
import HomeBanner from './components/HomeBanner.vue'
import HomeHeadlines from './components/HomeHeadlines.vue'
import HomeCarousel from './components/HomeCarousel.vue'
import HomeMarket from './components/HomeMarket.vue'
import HomeTags from './components/HomeTags.vue'
import HomeSection from './components/HomeSection.vue'
import HomeVideo from './components/HomeVideo.vue'
import HomeAds from './components/HomeAds.vue'
import HomePartners from './components/HomePartners.vue'
import HomeProject from './components/HomeProject.vue'
import PageFooter from '../detail/components/PageFooter.vue'
import { getCategoryInfoByNames } from '../../api/category'

import '../detail/assets/css/header.css'

export default {
  name: 'Home',
  metaInfo: {
    title: '中国品牌网 - 专业品牌服务 | 国家市场监督管理总局主管',
    meta: [
      {
        name: 'keywords',
        content: '中国品牌网，品牌，中国品牌，品牌网'
      },
      {
        name: 'description',
        content: '中国品牌网是中国品牌杂志社战略布局融媒体建设的重要互联网媒体平台之一，与中国品牌杂志形成刊网融合发展的联动格局，共同为促进中国品牌建设，推动质量强国、品牌强国发挥新闻媒体的舆论引领和监督作用。'
      }
    ]
  },
  components: {
    PageHeader,
    HomeBanner,
    HomeHeadlines,
    HomeCarousel,
    HomeMarket,
    HomeTags,
    HomeSection,
    HomeVideo,
    HomeAds,
    HomePartners,
    HomeProject,
    PageFooter
  },
  data() {
    return {
      showSkeleton: true,
      showFixedBanner: false,
      tripleAds: [
        require('./img/FigmaDDSSlicePNGa0906c80d270b3b9e75669f036f30e3b.png'),
        require('./img/FigmaDDSSlicePNGa0906c80d270b3b9e75669f036f30e3b.png'),
        require('./img/FigmaDDSSlicePNGa0906c80d270b3b9e75669f036f30e3b.png')
      ],
      categoryMap: {} // 存储所有分类的 id 和 templatePath
    }
  },
  mounted() {
    // 首页挂载后短暂展示骨架屏，避免白屏闪烁
    this.$nextTick(() => {
      setTimeout(() => {
        this.showSkeleton = false
      }, 800)
    })
    this.handleScroll()
    window.addEventListener('scroll', this.handleScroll, { passive: true })
    this.loadCategoryInfo()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    async loadCategoryInfo() {
      try {
        const result = await getCategoryInfoByNames([
          '市场监管',
          '资讯',
          '快消',
          '农业',
          '视频',
          '观察',
          '科技',
          '汽车',
          '食品',
          '文产',
          '话题',
          '品鉴',
          '原创'
        ])
        
        if (result && result.code === 200 && result.data) {
          // 构建 name -> id 和 templatePath 的映射表
          this.categoryMap = result.data.reduce((map, item) => {
            map[item.name] = {
              id: item.id,
              templatePath: item.templatePath
            }
            return map
          }, {})
        }
      } catch (e) {
        console.error('获取分类信息失败', e)
      }
    },
    handleScroll() {
      const homeTagsEl = this.$refs.homeTags && this.$refs.homeTags.$el
      if (!homeTagsEl) {
        this.showFixedBanner = false
        return
      }
      const rect = homeTagsEl.getBoundingClientRect()
      const homeTagsBottom = rect.bottom + window.pageYOffset
      this.showFixedBanner = window.pageYOffset > homeTagsBottom
    }
  }
}
</script>

<style scoped >
.home-page {
  width: 1400px;
  min-height: 100vh;
  margin: 0 auto;
  background: #fff;
}

/* 骨架屏 */
.home-skeleton {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background: #fff;
  overflow-y: auto;
}
.skeleton-wrap {
  width: 1400px;
  margin: 0 auto;
  padding-bottom: 40px;
}
.skeleton-fade-leave-active {
  transition: opacity 0.4s ease;
}
.skeleton-fade-leave-to {
  opacity: 0;
}
.skeleton-header,
.skeleton-banner,
.skeleton-headline-title,
.skeleton-headline-item,
.skeleton-carousel-main,
.skeleton-side-top,
.skeleton-side-btm,
.skeleton-market,
.skeleton-tags,
.skeleton-sec-title,
.skeleton-sec-left,
.skeleton-sec-right,
.skeleton-ad-item,
.skeleton-video-top,
.skeleton-video-bottom,
.skeleton-partners,
.skeleton-project,
.skeleton-footer {
  background: linear-gradient(90deg, #f2f2f2 25%, #e6e6e6 50%, #f2f2f2 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.6s infinite linear;
  border-radius: 4px;
}
@keyframes skeleton-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
.skeleton-header {
  width: 100%;
  height: 60px;
  margin-bottom: 20px;
}
.skeleton-banner {
  width: 100%;
  height: 94px;
  margin-bottom: 20px;
}
.skeleton-headlines {
  width: 100%;
  height: 190px;
  margin-bottom: 20px;
}
.skeleton-headline-title {
  width: 1040px;
  height: 53px;
  margin: 0 auto 36px;
}
.skeleton-headline-list {
  display: flex;
  justify-content: space-between;
  padding: 0 8px;
}
.skeleton-headline-item {
  width: 340px;
  height: 31px;
}
.skeleton-carousel {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}
.skeleton-carousel-main {
  width: 1040px;
  height: 498px;
}
.skeleton-carousel-side {
  width: 320px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-left: 17px;
}
.skeleton-side-top,
.skeleton-side-btm {
  width: 100%;
  height: 240px;
}
.skeleton-market {
  width: 100%;
  height: 190px;
  margin-bottom: 20px;
}
.skeleton-tags {
  width: 100%;
  height: 346px;
  margin-bottom: 20px;
}
.skeleton-section {
  margin-bottom: 20px;
}
.skeleton-sec-title {
  width: 261px;
  height: 45px;
  margin-bottom: 15px;
}
.skeleton-sec-body {
  display: flex;
  gap: 35px;
}
.skeleton-sec-left {
  width: 1040px;
  height: 310px;
}
.skeleton-sec-right {
  width: 320px;
  height: 310px;
}
.skeleton-ads-row {
  display: flex;
  gap: 28px;
  margin-bottom: 20px;
}
.skeleton-ad-item {
  width: 447px;
  height: 150px;
}
.skeleton-video {
  margin-bottom: 20px;
}
.skeleton-video-top {
  width: 100%;
  height: 167px;
  margin-bottom: 20px;
}
.skeleton-video-bottom {
  width: 100%;
  height: 374px;
}
.skeleton-partners {
  width: 100%;
  height: 160px;
  margin-bottom: 20px;
}
.skeleton-project {
  width: 100%;
  height: 240px;
  margin-bottom: 20px;
}
.skeleton-footer {
  width: 100%;
  height: 120px;
}
</style>
